import script from "./AdminUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminUser.vue?vue&type=script&setup=true&lang=ts"

import "./AdminUser.vue?vue&type=style&index=0&id=28bc3d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bc3d2e"]])

export default __exports__